import * as Html from "../../util/Html.ts";
import * as validator from "./validator.js";
export {init,destroy}
Html.registerWidget('widget/form/textarea-onenter-submit',{init:init,destroy:destroy})

function keypresscontroller(evt){
  if(evt.keyCode===13 || evt.keyCode===10){
    if(evt.altKey || evt.ctrlKey  || evt.shiftKey ){
    }else{
      evt.preventDefault();
      $(this).parents('form').trigger('submit');
    }
  }
}

function init(obj){
  validator.init(obj);
  obj.on('keypress',keypresscontroller);
}
function destroy(obj){
  obj.off('keypress',keypresscontroller);
}
